<template>
  <div class="actSlider-content">
    <div class="content-title">
      <div class="title-left">
        {{ lan ? showData.activityEnTitle : showData.activityCnTitle }}
        <div class="activityEnSubTitle" v-if="showData.activityEnSubTitle">
          {{ lan ? showData.activityEnSubTitle : showData.activityCnSubTitle }}
        </div>
      </div>
      <div class="title-right-btn" v-if="showData.showImg.length > 3">
        <img
          class="leftArr"
          @click="toLeft"
          v-if="canScrollLeft"
          src="../../assets/rightArr_black.png"
          alt="向左滚动"
        />
        <img
          class="leftArr"
          @click="toLeft"
          v-else
          src="../../assets/rightArr_gery.png"
          alt="已到最左侧"
        />
        <img
          class="rightArr"
          @click="toRight"
          v-if="canScrollRight"
          src="../../assets/rightArr_black.png"
          alt="向右滚动"
        />
        <img
          class="rightArr"
          @click="toRight"
          v-else
          src="../../assets/rightArr_gery.png"
          alt="已到最右侧"
        />
      </div>
    </div>
    <div 
      class="actSlider-content-info" 
      :id="`cultural${showNumber}`"
      @scroll="onScroll"
      ref="scrollContainer"
    >
      <div
        class="cultural-item"
        v-for="(item, index) in showData.showImg"
        :key="index"
      >
        <img :src="item.src" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showData: {
      type: Object,
      default: () => ({}),
    },
    showNumber: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      canScrollLeft: false,
      canScrollRight: true,
      lan: this.$store.state.isEn,
      resizeObserver: null,
    };
  },
  watch: {
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
    },
    showData: {
      handler() {
        this.$nextTick(() => {
          this.checkScrollButtons();
        });
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.checkScrollButtons();
      this.initResizeObserver();
    });
    
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 清理事件监听器
    window.removeEventListener('resize', this.handleResize);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    initResizeObserver() {
      // 使用 ResizeObserver 监听容器尺寸变化
      if (window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(() => {
          this.checkScrollButtons();
        });
        if (this.$refs.scrollContainer) {
          this.resizeObserver.observe(this.$refs.scrollContainer);
        }
      }
    },
    handleResize() {
      // 防抖处理窗口大小变化
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.checkScrollButtons();
      }, 150);
    },
    onScroll() {
      // 防抖处理滚动事件
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.checkScrollButtons();
      }, 50);
    },
    checkScrollButtons() {
      const container = this.$refs.scrollContainer || document.getElementById(`cultural${this.showNumber}`);
      if (!container) return;
      
      const { scrollLeft, scrollWidth, clientWidth } = container;
      
      // 添加一个小的容差值，避免浮点数精度问题
      const tolerance = 1;
      
      // 检查是否可以向左滚动（未到最左侧）
      this.canScrollLeft = scrollLeft > tolerance;
      
      // 检查是否可以向右滚动（未到最右侧）
      this.canScrollRight = scrollLeft + clientWidth < scrollWidth - tolerance;
    },
    toLeft() {
      if (!this.canScrollLeft) return;
      
      const container = this.$refs.scrollContainer || document.getElementById(`cultural${this.showNumber}`);
      if (!container) return;
      
      const { clientWidth } = container;
      const scrollAmount = clientWidth * 0.8; // 每次滚动可视区域的80%
      
      container.scrollTo({
        left: Math.max(0, container.scrollLeft - scrollAmount),
        behavior: "smooth"
      });
      
      // 延迟检查按钮状态
      setTimeout(() => {
        this.checkScrollButtons();
      }, 300);
    },
    toRight() {
      if (!this.canScrollRight) return;
      
      const container = this.$refs.scrollContainer || document.getElementById(`cultural${this.showNumber}`);
      if (!container) return;
      
      const { clientWidth, scrollWidth } = container;
      const scrollAmount = clientWidth * 0.8; // 每次滚动可视区域的80%
      const maxScroll = scrollWidth - clientWidth;
      
      container.scrollTo({
        left: Math.min(maxScroll, container.scrollLeft + scrollAmount),
        behavior: "smooth"
      });
      
      // 延迟检查按钮状态
      setTimeout(() => {
        this.checkScrollButtons();
      }, 300);
    },
  },
};
</script>

<style scoped>
.content-title {
  width: 95%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0px 0 20px;
}
.title-right-btn {
  color: #98989f;
  cursor: pointer;
  margin-right: 5%;
}
.act-list {
  position: relative;
  background: #eaeaea;
}
.title-left {
  position: relative;
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
  display: flex;
}
.activityEnSubTitle {
  font-family: SourceHanSansCN-Regular;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 400;
  padding: 0 10px;
  height: 19px;
  margin: 10px 0 0 10px;
  background: url(../../assets/actTag.png) no-repeat center;
  background-size: cover;
  background-position: 50% 50%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.carousel {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.carousel-slides {
  display: flex;
  width: 1226px;
  transition: transform 0.5s ease;
  color: #000;
}
.carousel-slides .pc {
  width: 1226px;
  height: 640px;
}

.actSlider-content-info {
  width: 90%;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch; /* 移动端优化 */
}

.actSlider-content-info::-webkit-scrollbar {
  display: none;
}

.cultural-item {
  min-width: 394px;
  height: auto;
  margin-right: 22px;
}
.cultural-item:last-child {
  margin-right: 0;
}

.cultural-item img {
  min-width: 394px;
  height: 270px;
  object-fit: cover;
}
.rightArr {
  width: 32px;
  height: 20px;
}
.leftArr {
  width: 32px;
  height: 20px;
  transform: rotate(180deg);
}

/* 移动端触摸优化 */
@media (hover: none) and (pointer: coarse) {
  .title-right-btn {
    pointer-events: auto;
  }
  
  .leftArr, .rightArr {
    pointer-events: auto;
  }
}

@media (max-width: 1440px) {
  .content-title {
    position: relative;
    max-width: 95%;
  }
  .act-list {
    position: relative;
    background: #eaeaea;
    max-width: 80%;
  }
  .carousel {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .carousel-slides {
    display: flex;
    width: 100%;
    transition: transform 0.5s ease;
    color: #000;
  }
  .carousel-slides .pc {
    width: 222px;
    height: 222px;
  }

  .actSlider-content-info {
    max-width: 95%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .actSlider-content-info::-webkit-scrollbar {
    display: none;
  }

  .cultural-item {
    max-width: 222px;
    height: auto;
    margin-right: 10px;
  }
  .cultural-item:last-child {
    margin-right: 0;
  }

  .cultural-item img {
    max-width: 222px;
    height: auto;
    object-fit: cover;
  }
  .rightArr {
    width: 32px;
    height: 20px;
  }
  .leftArr {
    width: 32px;
    height: 20px;
    transform: rotate(180deg);
  }
}

@media (max-width: 960px) {
  .content-title {
    max-width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 12px;
  }
  .title-right-btn {
    margin-right: 2%;
    text-align: center;
  }
  .act-list {
    position: relative;
    background: #eaeaea;
  }
  .title-left {
    font-family: SourceHanSansCN-Bold;
    font-size: 20px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    max-width: 78%;
    display: flex;
    align-items: center;
  }
  .activityEnSubTitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 12px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    padding: 0 6px;
    height: 19px;
    width: auto;
    margin: 0 5px 0;
    background: url(../../assets/actTag.png) no-repeat center;
    background-size: cover;
    background-position: 50% 50%;
  }
  .carousel {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .carousel-slides {
    display: flex;
    width: 100%;
    transition: transform 0.5s ease;
    color: #000;
  }
  .carousel-slides .pc {
    width: 162px;
    height: 162px;
  }

  .actSlider-content-info {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
  }

  .actSlider-content-info::-webkit-scrollbar {
    display: none;
  }

  .cultural-item {
    min-width: 162px;
    width: 162px;
    height: auto;
    margin-right: 10px;
  }
  .cultural-item:last-child {
    margin-right: 0;
  }

  .cultural-item img {
    min-width: 162px;
    width: 162px;
    height: 162px;
    object-fit: cover;
  }
  .rightArr {
    width: 32px;
    height: 20px;
  }
  .leftArr {
    width: 32px;
    height: 20px;
    transform: rotate(180deg);
  }
}

@media (max-width: 768px) {
  .content-title {
    max-width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 10px;
  }
  .activityEnSubTitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 8px;
    color: #ffffff;
    line-height: 13px;
    text-align: center;
    font-weight: 400;
    padding: 0 4px;
    height: 13px;
    width: auto;
    background: url(../../assets/actTag.png) no-repeat center;
    background-size: cover;
    background-position: 50% 50%;
  }

  .rightArr {
    width: 26px;
    height: 18px;
  }
  .leftArr {
    width: 26px;
    height: 18px;
    transform: rotate(180deg);
  }
}
</style>